module.exports = __webpack_public_path__ + "img/pic_zxshi.2f6c624e.png";